<button [id]="'button_back-button_NavegarBack'" mat-icon-button (click)="backClicked()" [color]="color">
    <mat-icon aria-label="label">navigate_before</mat-icon>
</button>
